export default "__VITE_ASSET__gOdTw$PC__"